module.exports = __webpack_public_path__ + "static/img/bussinessTv3.18bcfdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bussinessTv3.png
// module id = TIcu
// module chunks = 2